import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { database } from "../../firebase";
import { ref, onValue, query, orderByChild, set, update, equalTo, runTransaction } from "firebase/database";
import { collection, doc, setDoc, updateDoc, getDocs, query as queryFirestore, where } from 'firebase/firestore';
import { getFirestore } from 'firebase/firestore';
import OutlinedInput from '@mui/material/OutlinedInput';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { idCuadrillaBodega } from '../../utils/default';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InputSerials from "../../components/InputSerials/InputSerials";
import { materialsValidate, servicesId } from "../../utils/validations";
import { getCuadrillaById, updateCuadrillaFirestore, updateCuadrillaConRegistro } from "../../services/cuadrillasService";
import { registrarUsoMateriales } from "../../services/registrosService";
import { getMaterialesOnce } from "../../services/materialsService";
import { filterMaterialesVisibles, isNoDescMaterial } from "../../utils/specialMaterials";
import moment from "moment";
import { Tooltip } from "@mui/material";

const firestore = getFirestore();
const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddMaterials({ nextStep, data, onSave }) {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    let { id } = useParams();
    const cuadrillaSelected = { id: data?.idCuadrilla, numero: data?.cuadrilla };
    const isMudanza = data?.tipoOt === 'Mudanza externa';

    const [state, setState] = useState({
        idOt: id,
        materials: [],
        materialsToSave: [],
        serialOnt: [],
        serialesFlow: [],
        serialesExt: [],
        ontRetirado: [],
        decoRetirado: [],
        extRetirado: [],
        controles: [],
        serialesConfigurados: {},
        ontBodega: [],
        flowBodega: [],
        extBodega: [],
        serialesToSave: [],
        checkField: false,

        submitted: false,
    })
    const [bodega, setBodega] = useState([]);
    const [cuadrilla, setCuadrilla] = useState([]);
    const [serialConfigList, setSerialConfigList] = useState([
        <TextField
            id="outlined-number"
            label="Serial equipo configurado"
            className="text-form__serial"
            onChange={(e) => onChangeValues(e, 0)}
            InputLabelProps={{
                shrink: true,
            }}
            sx={{ marginBottom: '20px', marginRight: '10px' }}
        />
    ]);
    const [materialsCuadrilla, setMaterialsCuadrilla] = useState([]);
    const [snackbarInfo, setSnackbarInfo] = useState({ text: '', type: '', open: false });
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [isOnSave, setIsOnSave] = useState(false);
    const [operationInProgress, setOperationInProgress] = useState(false);
    const operationInProgressRef = useRef(false);
    const [materialesPrecargados, setMaterialesPrecargados] = useState([]);
    const [noRequiereMaterialesFM, setNoRequiereMaterialesFM] = useState(false);
    const [materialesValidados, setMaterialesValidados] = useState({});
    const [expandirMateriales, setExpandirMateriales] = useState(true);
    const [alertValidationAdaptadorMecanico, setAlertValidationAdaptadorMecanico] = useState('');
    const [alertValidationRoseta, setAlertValidationRoseta] = useState('');
    const [alertValidationConectorSc, setAlertValidationConectorSc] = useState('');
    const [alertValidationRetenedor, setAlertValidationRetenedor] = useState('');
    const [alertValidationDropExterno, setAlertValidationDropExterno] = useState('');
    const [alertValidationCintas, setAlertValidationCintas] = useState('');
    const [alertValidationPreco50, setAlertValidationPreco50] = useState('');
    const [alertValidationPreco100, setAlertValidationPreco100] = useState('');
    const [alertValidationPreco150, setAlertValidationPreco150] = useState('');
    const [alertValidationPreco220, setAlertValidationPreco220] = useState('');
    const [alertValidationPreco300, setAlertValidationPreco300] = useState('');
    const [alertValidationSerialOnt, setAlertValidationSerialOnt] = useState('');
    const [alertValidationSerialFlow, setAlertValidationSerialFlow] = useState('');
    const [alertValidationRj, setAlertValidationRj] = useState('');

    const fetchMaterialsCuadrilla = async () => {
        try {
            // Referencia a la colección
            const materialsCuadrillaCollection = collection(firestore, 'materialsxcuadrilla');

            // Consulta con filtro por idCuadrilla
            const cuadrillaQuery = query(
                materialsCuadrillaCollection,
                where('idCuadrilla', '==', parseInt(cuadrillaSelected.id, 10))
            );

            // Obtener los documentos de la consulta
            const querySnapshot = await getDocs(cuadrillaQuery);

            if (!querySnapshot.empty) {
                // Extraer los datos de los documentos
                const materials = querySnapshot.docs.map(doc => doc.data());
                setMaterialsCuadrilla(materials);
            } else {
                setMaterialsCuadrilla([]);
            }
        } catch (error) {
            console.error('Error al obtener materialsxcuadrilla:', error);
            setSnackbarInfo({ text: 'Ocurrió un error al cargar los materiales', type: 'error', open: true });
        }
    };

    useEffect(() => {
        // onValue(ref(database, '/materiales/'), (snapshot) => {
        //     setState(prevState => ({ ...prevState, materials: snapshot.val() }));
        //     countDigits(data?.contrato, snapshot.val())
        // }, {
        //     onlyOnce: true
        // });
        getMaterialesOnce(setState)
        fetchMaterialsCuadrilla();

        // Inicializar checkField desde data
        const initialCheckField = !!(data?.checkField);
        setState(prev => ({
            ...prev,
            checkField: initialCheckField
        }));

        // Cargar materiales precargados desde data
        if (data?.materialesPrecargados && data.materialesPrecargados.length > 0) {
            const precargadosVisibles = filterMaterialesVisibles(data.materialesPrecargados);
            setMaterialesPrecargados(precargadosVisibles);
            setNoRequiereMaterialesFM(
                data.noRequiereMateriales || data.materialesPrecargados.some(isNoDescMaterial)
            );
            const validados = {};
            precargadosVisibles.forEach(material => {
                validados[material.materialId] = false;
            });
            setMaterialesValidados(validados);
            console.log('📦 Materiales precargados cargados:', precargadosVisibles);
        }
        // countDigits(data?.contrato, state?.materials)

        // Cargar materiales desde Firestore si no vinieron en data pero tenemos ID de cuadrilla
        if ((!data?.materialesPrecargados || data.materialesPrecargados.length === 0) && data?.idCuadrilla && id) {
            loadMaterialesFromFirestore(data.idCuadrilla, id);
        }

        // const cuadrilla = query(ref(database, 'materialsxcuadrilla'), orderByChild('idCuadrilla'), equalTo(parseInt(cuadrillaSelected.id, 10)));
        // onValue(cuadrilla, (snapshot) => {
        //     if (snapshot.val()) {
        //         setMaterialsCuadrilla(Object.values(snapshot.val()))
        //     } else {
        //         setMaterialsCuadrilla([]);
        //     }
        // }, {
        //     onlyOnce: true
        // });

        // const bodega = query(ref(database, 'cuadrillas'), orderByChild('id'), equalTo(idCuadrillaBodega));
        // onValue(bodega, (snapshot) => {
        //     setBodega(Object.values(snapshot.val())[0])
        // }, {
        //     onlyOnce: true
        // });
        // const cuadrillaQuery = query(ref(database, 'cuadrillas'), orderByChild('id'), equalTo(parseInt(cuadrillaSelected.id, 10)));
        // onValue(cuadrillaQuery, (snapshot) => {
        //     setCuadrilla(Object.values(snapshot.val())[0])
        // }, {
        //     onlyOnce: true
        // });

        //GetBodega
        getCuadrillaById(idCuadrillaBodega, setBodega);
        //GetCuadrillaSelected
        getCuadrillaById(parseInt(cuadrillaSelected.id, 10), setCuadrilla);



        // PARA EL EDIT
        // const orderQuery = query(ref(database, 'ordenes'), orderByChild('id'), equalTo(parseInt(id, 10)));
        // onValue(orderQuery, (snapshot) => {
        //     const order = Object.values(snapshot.val());
        //     console.log(order[0].materials);
        //     setState(prevState =>
        //     ({ ...prevState,
        //         materialsToSave: order[0]?.materials,
        //         serialOnt: order[0]?.serialOnt,
        //         serialesFlow: order[0]?.serialesFlow,
        //         ontRetirado: order[0]?.ontRetirado,
        //         decoRetirado: order[0]?.decoRetirado,
        //         controles: order[0]?.controles,
        //         serialesConfigurados: order[0]?.serialesConfigurados,
        //         comments: order[0]?.comments,
        //     }))
        // }, {
        //     onlyOnce: true
        // });

    }, []);

    useEffect(() => {
        if (state.materials.length > 0) {
            countDigits(data?.contrato, state.materials);
        }
    }, []);


    // Contraer materiales automáticamente cuando todos estén validados
    useEffect(() => {
        if (todosMaterialesPrecargadosValidados() && materialesPrecargados.length > 0) {
            setExpandirMateriales(false);
        }
    }, [materialesValidados]);

    // Cargar materiales desde Firestore si no vinieron en data
    const loadMaterialesFromFirestore = async (idCuadrilla, workOrder) => {
        try {
            const firestore = getFirestore();
            const cuadrillaQuery = queryFirestore(
                collection(firestore, 'cuadrillas'),
                where('id', '==', parseInt(idCuadrilla, 10))
            );
            const cuadrillaSnapshot = await getDocs(cuadrillaQuery);

            if (cuadrillaSnapshot.empty) {
                console.warn(`Cuadrilla con ID ${idCuadrilla} no encontrada`);
                return;
            }

            const cuadrillaData = cuadrillaSnapshot.docs[0].data();
            if (cuadrillaData.ordenes && Array.isArray(cuadrillaData.ordenes)) {
                const orden = cuadrillaData.ordenes.find(
                    o => o.workOrder?.toString().trim() === workOrder?.toString().trim()
                );

                if (orden) {
                    const initialCheckField = !!(orden.checkField);
                    setState(prev => ({
                        ...prev,
                        checkField: initialCheckField
                    }));

                    if (orden.materiales && orden.materiales.length > 0) {
                        const precargadosVisibles = filterMaterialesVisibles(orden.materiales);
                        setMaterialesPrecargados(precargadosVisibles);
                        setNoRequiereMaterialesFM(
                            orden.noRequiereMateriales || orden.materiales.some(isNoDescMaterial)
                        );
                        const validados = {};
                        precargadosVisibles.forEach(material => {
                            validados[material.materialId] = false;
                        });
                        setMaterialesValidados(validados);
                        console.log('📦 Materiales cargados desde Firestore:', precargadosVisibles);
                    }
                }
            }
        } catch (error) {
            console.error('Error al cargar materiales desde Firestore:', error);
        }
    };

    const countDigits = (str, materials) => {
        const digitArray = str.split('');
        const digitCounts = {};

        digitArray.forEach(digit => {
            digitCounts[digit] = (digitCounts[digit] || 0) + 1;
        });

        const keytDigit = Object.keys(digitCounts);
        const initId = 27;
        let newData = [];

        keytDigit.forEach(digit => {
            const indexMaterial = initId + parseInt(digit, 10);
            const formatData = {
                id: materials[indexMaterial]?.id,
                name: materials[indexMaterial]?.name,
                value: digitCounts[digit],
            };

            if (formatData.id) {
                newData.push(formatData);
            }
        });

        setState(prevState => {
            const updatedMaterials = [...prevState.materialsToSave, ...newData].filter(
                (item, index, self) => index === self.findIndex(t => t.id === item.id)
            );

            return { ...prevState, materialsToSave: updatedMaterials };
        });
    };

    const handleValidarMaterialPrecargado = (materialId) => {
        const isChecked = !materialesValidados[materialId];

        setMaterialesValidados(prev => ({
            ...prev,
            [materialId]: isChecked
        }));

        // Si se marca como revisado, agregar a materialsToSave
        if (isChecked) {
            const material = materialesPrecargados.find(m => m.materialId === materialId);
            if (material) {
                setState(prevState => {
                    const newMaterial = {
                        id: material.materialId,
                        name: material.name,
                        value: material.cantidad
                    };
                    // Evitar duplicados
                    const exists = prevState.materialsToSave.some(m => m.id === newMaterial.id);
                    if (exists) {
                        return prevState;
                    }
                    return { ...prevState, materialsToSave: [...prevState.materialsToSave, newMaterial] };
                });
                console.log(`✅ Material agregado a materialsToSave: ${material.name}`);
            }
        } else {
            // Si se desmarca, remover de materialsToSave
            setState(prevState => {
                return {
                    ...prevState,
                    materialsToSave: prevState.materialsToSave.filter(m => m.id !== materialId)
                };
            });
            console.log(`❌ Material removido de materialsToSave: ${materialId}`);
        }
    };

    const todosMaterialesPrecargadosValidados = () => {
        if (materialesPrecargados.length === 0) {
            return true; // Si no hay materiales precargados, está OK
        }
        return Object.values(materialesValidados).every(validado => validado === true);
    };

    const changeInput = (e, id, name) => {
        const formatData = { id, name, value: e.target.value }
        const filterService = state.materialsToSave.filter(service => service.id === id);
        let newData = [];
        const keys = Object.keys(state.materialsToSave);
        if (filterService.length > 0) {
            let materialNewArray = [...state.materialsToSave]
            const keyService = keys.filter(key => state.materialsToSave[key].id === id);
            let materialToEdit = { ...materialNewArray[keyService] };
            materialToEdit.value = e.target.value
            materialNewArray[keyService] = materialToEdit
            setState(prevState => ({ ...prevState, materialsToSave: materialNewArray }));
        } else {
            newData = [...state.materialsToSave, formatData]
            setState(prevState => ({ ...prevState, materialsToSave: newData }));
        }

        if (e.target.value === '') {
            let materialNewArray = [...state.materialsToSave]
            const keyService = keys.filter(key => state.materialsToSave[key].id === id);
            materialNewArray.splice(parseInt(keyService[0], 10), 1);
            setState(prevState => ({ ...prevState, materialsToSave: materialNewArray }));
        }
    }

    const onChangeValues = (e, idSerial) => {
        const value = e.target.value;
        let newData = Object.assign(state.serialesConfigurados, { [idSerial]: value })
        setState(prevState => ({
            ...prevState,
            serialesConfigurados: newData
        }));
    };

    const onChangeControles = (e, id, name) => {
        const valued = e.target.value
        const value = valued ? parseInt(valued, 10) : 0;
        const formatData = { id, name, value }
        const filterService = state.controles.filter(service => service.id === id);
        let newData = [];
        const keys = Object.keys(state.controles);
        if (filterService.length > 0) {
            let materialNewArray = [...state.controles]
            const keyService = keys.filter(key => state.controles[key].id === id);
            let materialToEdit = { ...materialNewArray[keyService] };
            materialToEdit.value = e.target.value
            materialNewArray[keyService] = materialToEdit
            setState(prevState => ({ ...prevState, controles: materialNewArray }));
        } else {
            newData = [...state.controles, formatData]
            setState(prevState => ({ ...prevState, controles: newData }));
        }
    };

    const onAddBtnClick = (e, type) => {
        e.preventDefault();
        if (type === 'serial') {
            setSerialConfigList(serialConfigList.concat(
                <TextField
                    id="outlined-number"
                    label="Serial equipo configurado"
                    key={serialConfigList.length}
                    onChange={(e) => onChangeValues(e, serialConfigList.length)}
                    className="text-form__serial"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    sx={{ marginBottom: '20px', marginRight: '10px' }}
                />
            ));
        }
    };

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    const onChangeSerialOnt = (event, serialsSelected) => {
        const serialOntSelected = serialsSelected ? [serialsSelected?.id] : [];
        setState(prevState =>
        ({
            ...prevState,
            serialOnt: serialOntSelected
        }));
    }

    const onChangeSeriales = (event, serialsSelected, name) => {
        const serialOntBodega = serialsSelected ? [serialsSelected?.id] : [];
        const serialToSave = name !== 'ontBodega' ? serialsSelected.map(serial => serial.id) : serialOntBodega;
        setState(prevState =>
        ({
            ...prevState,
            [name]: serialToSave
        }));
    }

    const verifySerialIntegrity = (beforeSerials, afterSerials, excludedSerials) => {
        const beforeCount = beforeSerials?.length || 0;
        const afterCount = afterSerials?.length || 0;
        const excludedCount = excludedSerials?.length || 0;

        const expectedCount = beforeCount - excludedCount;

        if (afterCount !== expectedCount) {
            console.warn(`⚠️ Posible pérdida de seriales detectada:
                - Antes: ${beforeCount} seriales
                - Excluidos: ${excludedCount} seriales
                - Esperados después: ${expectedCount} seriales
                - Reales después: ${afterCount} seriales
                - Diferencia: ${expectedCount - afterCount} seriales`);

            // Encontrar qué seriales se perdieron
            const beforeIds = beforeSerials?.map(s => s.id) || [];
            const afterIds = afterSerials?.map(s => s.id) || [];
            const lostSerials = beforeIds.filter(id => !afterIds.includes(id) && !excludedSerials.includes(id));

            if (lostSerials.length > 0) {
                console.error('🔴 Seriales perdidos:', lostSerials);
                return false;
            }
        }

        return true;
    };

    // ✅ NUEVA FUNCIÓN: Versión promisificada de getCuadrillaById
    const getCuadrillaActualizada = (idCuadrilla) => {
        return new Promise((resolve, reject) => {
            try {
                getCuadrillaById(idCuadrilla, (cuadrillaData) => {
                    resolve(cuadrillaData);
                });

                // Timeout de seguridad en caso de que la callback no se ejecute
                setTimeout(() => {
                    reject(new Error('Timeout al obtener cuadrilla actualizada'));
                }, 10000); // 10 segundos para operaciones de BD bajo carga
            } catch (error) {
                reject(error);
            }
        });
    };

    // ✅ FUNCIÓN ACTUALIZADA: Obtiene datos frescos antes de modificar
    const prepararCuadrillaModificada = async () => {
        console.log('🔄 Obteniendo datos actualizados de la cuadrilla...');

        // ✅ CRÍTICO: Obtener la cuadrilla más reciente desde la base de datos
        let cuadrillaActualizada = null;

        try {
            console.log('🔄 Solicitando cuadrilla actualizada desde BD...');
            cuadrillaActualizada = await getCuadrillaActualizada(parseInt(cuadrillaSelected.id, 10));

            console.log('✅ Cuadrilla actualizada obtenida desde base de datos');
            console.log('📊 Seriales actuales en DB:', cuadrillaActualizada.seriales?.length || 0);
            console.log('📊 Seriales en cache local:', cuadrilla.seriales?.length || 0);

            const diferencia = (cuadrillaActualizada.seriales?.length || 0) - (cuadrilla.seriales?.length || 0);
            if (diferencia !== 0) {
                console.log(`🔄 Diferencia detectada: ${diferencia > 0 ? '+' : ''}${diferencia} seriales`);

                if (diferencia > 0) {
                    setSnackbarInfo({
                        text: `Se detectaron ${diferencia} seriales nuevos agregados recientemente. Usando datos actualizados.`,
                        type: 'info',
                        open: true
                    });
                }
            }

            // Actualizar el estado local para mantener consistencia
            setCuadrilla(cuadrillaActualizada);

        } catch (error) {
            console.error('❌ Error al obtener cuadrilla actualizada:', error);
            console.warn('⚠️ Usando datos del cache local como fallback');
            cuadrillaActualizada = cuadrilla;

            setSnackbarInfo({
                text: 'Advertencia: No se pudieron obtener los datos más recientes. Usando cache local.',
                type: 'warning',
                open: true
            });
        }

        // Crear una copia profunda de la cuadrilla actualizada
        const cuadrillaCopy = { ...cuadrillaActualizada };

        // Guardar estado inicial para verificación
        const initialSerials = cuadrillaCopy.seriales || [];

        // Seriales usados - incluir todos los tipos de seriales (normales, mudanza y configurados)
        const configuredSerials = state.serialesConfigurados && typeof state.serialesConfigurados === 'object'
            ? Object.values(state.serialesConfigurados).map(v => typeof v === 'object' ? v?.id : v).filter(Boolean)
            : [];
        const mudanzaSerials = Array.isArray(state.serialesToSave)
            ? state.serialesToSave.map(s => typeof s === 'object' ? s?.id : s).filter(Boolean)
            : [];
        const serialsToExclude = Array.from(new Set([
            ...(state.serialOnt || []),
            ...(state.serialesFlow || []),
            ...(state.serialesExt || []),
            ...mudanzaSerials,
            ...configuredSerials
        ].map(s => String(s || '').trim()).filter(Boolean)));
        const serialsToExcludeUpper = new Set(serialsToExclude.map(s => s.toUpperCase()));

        console.log('🔄 Preparando cuadrilla modificada');
        console.log('Seriales a excluir:', serialsToExclude);
        console.log('Seriales iniciales:', initialSerials.map(s => s.id));

        // Filtrar seriales por ID (case-insensitive) en lugar de por índice para mayor precisión
        const newArrayCuadrilla = cuadrillaCopy.seriales?.filter(serial =>
            !serialsToExcludeUpper.has(String(serial?.id || '').trim().toUpperCase())
        ) || [];

        // Verificar integridad de seriales
        const integrityCheck = verifySerialIntegrity(initialSerials, newArrayCuadrilla, serialsToExclude);

        if (!integrityCheck) {
            console.error('❌ Fallo en la verificación de integridad de seriales');
            setSnackbarInfo({
                text: 'Advertencia: Se detectó una posible pérdida de seriales. Revise los logs para más detalles.',
                type: 'warning',
                open: true
            });
        } else {
            console.log('✅ Verificación de integridad de seriales exitosa');
        }

        cuadrillaCopy.seriales = newArrayCuadrilla;
        console.log('Seriales después del filtrado:', newArrayCuadrilla.map(s => s.id));

        //Controles - crear copia para evitar mutaciones
        let newArrayControlsEntrega = [...(cuadrillaCopy?.controles || [])];

        state.controles.forEach(control => {
            const existingControlIndex = newArrayControlsEntrega.findIndex(cont => cont.id === control.id);

            if (existingControlIndex !== -1) {
                // Si el control ya existe, actualizar su valor
                newArrayControlsEntrega[existingControlIndex] = {
                    ...newArrayControlsEntrega[existingControlIndex],
                    value: newArrayControlsEntrega[existingControlIndex].value - control.value
                };
            } else {
                // Si el control no existe, agregarlo
                const formatControl = {
                    id: control.id,
                    name: control.name,
                    value: -control.value
                };
                newArrayControlsEntrega.push(formatControl);
            }
        });

        cuadrillaCopy.controles = newArrayControlsEntrega;

        console.log('✅ Cuadrilla preparada con datos actualizados');
        console.log('📊 Resumen de la operación:');
        console.log(`   - Seriales iniciales: ${initialSerials.length}`);
        console.log(`   - Seriales a excluir: ${serialsToExclude.length}`);
        console.log(`   - Seriales finales: ${cuadrillaCopy.seriales?.length || 0}`);
        console.log(`   - Verificación: ${integrityCheck ? '✅ Exitosa' : '❌ Falló'}`);

        // Devolver el objeto modificado para uso inmediato
        return cuadrillaCopy;
    }

    // Mantener la función original para compatibilidad (si se usa en otro lugar)
    const setNewCuadrillas = () => {
        prepararCuadrillaModificada();
    }


    const validations = () => {
        let countErrors = 0
        const serviceSelected = data?.services[0]
        const preco50 = state.materialsToSave.filter(material => material.id === materialsValidate.PRECO_50.id)
        const preco100 = state.materialsToSave.filter(material => material.id === materialsValidate.PRECO_100.id)
        const preco150 = state.materialsToSave.filter(material => material.id === materialsValidate.PRECO_150.id)
        const preco220 = state.materialsToSave.filter(material => material.id === materialsValidate.PRECO_220.id)
        const preco300 = state.materialsToSave.filter(material => material.id === materialsValidate.PRECO_300.id)

        const conectorSc = state.materialsToSave.filter(material => material.id === materialsValidate.CONECTOR_SC.id)
        const dropExterno = state.materialsToSave.filter(material => material.id === materialsValidate.DROP_EXTERNO.id)
        const retenedor = state.materialsToSave.filter(material => material.id === materialsValidate.RETENEDOR.id)
        const adaptadorMecanico = state.materialsToSave.filter(material => material.id === materialsValidate.ADAPTADOR_MECANICO.id)
        const roseta = state.materialsToSave.filter(material => material.id === materialsValidate.ROSETA_OPTICA.id)
        const cintaMetalica = state.materialsToSave.filter(material => material.id === materialsValidate.CINTA_METALICA.id)
        const ojal = state.materialsToSave.filter(material => material.id === materialsValidate.OJAL.id)
        const hebilla = state.materialsToSave.filter(material => material.id === materialsValidate.HEBILLA.id)
        const utp = state.materialsToSave.filter(material => material.id === materialsValidate.UTP5E.id)
        const rj45 = state.materialsToSave.filter(material => material.id === materialsValidate.RJ45.id)

        if (preco50?.length > 0 && parseInt(preco50[0]?.value, 10) > materialsValidate.PRECO_50.maxQuantity) {
            setAlertValidationPreco50(`La cantidad en ${preco50[0]?.name} debe ser como máximo ${materialsValidate.PRECO_50.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationPreco50('')
        }
        if (preco100?.length > 0 && parseInt(preco100[0]?.value, 10) > materialsValidate.PRECO_100.maxQuantity) {
            setAlertValidationPreco100(`La cantidad en ${preco100[0]?.name} debe ser como máximo ${materialsValidate.PRECO_100.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationPreco100('')
        }
        if (preco150?.length > 0 && parseInt(preco150[0]?.value, 10) > materialsValidate.PRECO_150.maxQuantity) {
            setAlertValidationPreco150(`La cantidad en ${preco150[0]?.name} debe ser como máximo ${materialsValidate.PRECO_150.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationPreco150('')
        }
        if (preco220?.length > 0 && parseInt(preco220[0]?.value, 10) > materialsValidate.PRECO_220.maxQuantity) {
            setAlertValidationPreco220(`La cantidad en ${preco220[0]?.name} debe ser como máximo ${materialsValidate.PRECO_220.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationPreco220('')
        }
        if (preco300?.length > 0 && parseInt(preco300[0]?.value, 10) > materialsValidate.PRECO_300.maxQuantity) {
            setAlertValidationPreco300(`La cantidad en ${preco300[0]?.name} debe ser como máximo ${materialsValidate.PRECO_300.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationPreco300('')
        }
        if (dropExterno?.length > 0 &&
            (parseInt(dropExterno[0]?.value, 10) <= materialsValidate.DROP_EXTERNO.minQuantity ||
                parseInt(dropExterno[0]?.value, 10) > materialsValidate.DROP_EXTERNO.maxQuantity)
        ) {
            setAlertValidationDropExterno(
                `La cantidad en ${dropExterno[0]?.name} debe ser como mínimo ${materialsValidate.DROP_EXTERNO.minQuantity} y máximo ${materialsValidate.DROP_EXTERNO.maxQuantity}`
            )
            countErrors += 1;
        } else {
            setAlertValidationDropExterno('')
        }
        if (retenedor?.length > 0 && parseInt(retenedor[0]?.value, 10) > materialsValidate.RETENEDOR.maxQuantity) {
            setAlertValidationRetenedor(`La cantidad en ${retenedor[0]?.name} debe ser como máximo ${materialsValidate.RETENEDOR.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationRetenedor('')
        }
        if (conectorSc?.length > 0) {
            const conectorValue = parseInt(conectorSc[0]?.value, 10) || 0;
            const hasRoseta = roseta?.length > 0;

            const maxAllowed = hasRoseta
                ? materialsValidate.CONECTOR_SC.maxQuantityWithRoseta
                : materialsValidate.CONECTOR_SC.maxQuantity;

            if (conectorValue > maxAllowed) {
                setAlertValidationConectorSc(`La cantidad en ${conectorSc[0]?.name} debe ser como máximo ${maxAllowed}`);
                countErrors += 1;
            } else {
                setAlertValidationConectorSc('');
            }
        }
        if (adaptadorMecanico?.length > 0 && parseInt(adaptadorMecanico[0]?.value, 10) > materialsValidate.ADAPTADOR_MECANICO.maxQuantity) {
            setAlertValidationAdaptadorMecanico(`La cantidad en ${adaptadorMecanico[0]?.name} debe ser como máximo ${materialsValidate.ADAPTADOR_MECANICO.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationAdaptadorMecanico('')
        }
        if (roseta?.length > 0 && parseInt(roseta[0]?.value, 10) > materialsValidate.ROSETA_OPTICA.maxQuantity) {
            setAlertValidationRoseta(`La cantidad en ${roseta[0]?.name} debe ser como máximo ${materialsValidate.ROSETA_OPTICA.maxQuantity}`)
            countErrors += 1;
        } else {
            setAlertValidationRoseta('')
        }
        if (cintaMetalica?.length > 0 || hebilla?.length > 0 || ojal?.length > 0) {

            if (cintaMetalica?.length > 0 && hebilla?.length > 0 && ojal?.length > 0) {
                setAlertValidationCintas('')
            } else {
                setAlertValidationCintas(`Los campos Cinta Metalica Abrazadera (mts), Ojal de acero Galvanizado (unid) y Hebilla Abrazadera de Fijacion (Unid) todos deben tener valores si al menos uno de ellos tiene un valor`)
                countErrors += 1;
            }
        }
        const filterSToSave = state.serialesToSave?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'ont')
        if ((serviceSelected?.id === servicesId.BASICA1P) &&
            (state.serialOnt.length === 0 && filterSToSave?.length === 0 && state.ontBodega.length === 0)) {
            setAlertValidationSerialOnt(`Debe seleccionar un serial ONT al tener seleccionado ${serviceSelected?.name}`)
            countErrors += 1;
        } else {
            setAlertValidationSerialOnt('')
        }
        const filterFToSave = state.serialesToSave?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'flow')
        if ((serviceSelected?.id === servicesId.BASICA2P) &&
            ((state.serialOnt.length === 0 && filterSToSave?.length === 0 && state.ontBodega.length === 0) ||
                (state.serialesFlow.length === 0 && filterFToSave?.length === 0 && state.flowBodega.length === 0))
        ) {
            setAlertValidationSerialOnt(`Debe seleccionar un serial ONT al tener seleccionado ${serviceSelected?.name}`)
            countErrors += 1;
        } else {
            setAlertValidationSerialOnt('')
        }

        if ((serviceSelected?.id === servicesId.SOLOFLOW) &&
            state.serialesFlow.length === 0 && state.flowBodega.length === 0) {
            setAlertValidationSerialFlow(`Debe seleccionar al menos un serial FLOW al tener seleccionado ${serviceSelected?.name}`)
            countErrors += 1;
        } else {
            setAlertValidationSerialFlow('')
        }
        if (utp?.length > 0 && rj45?.length === 0) {
            setAlertValidationRj(`Para tener valor en Cable UTP Cat 5e (mts) debe tener cargado tambien al menos una unidad en Fichas RJ45`)
            countErrors += 1;
        } else {
            setAlertValidationRj('')
        }

        return countErrors > 0 ? false : true;
    }

    const saveMaterials = async () => {
        // Prevenir operaciones concurrentes (useRef es síncrono, protege contra doble-click)
        if (operationInProgressRef.current) {
            console.warn('⚠️ Operación ya en progreso, ignorando nueva solicitud');
            return;
        }

        operationInProgressRef.current = true;
        setOperationInProgress(true);
        setIsOnSave(true);

        const validateResult = validations();

        // Validar que los materiales precargados estén validados
        if (!todosMaterialesPrecargadosValidados()) {
            setSnackbarInfo({
                text: '⚠️ Debes validar (marcar el checkbox) todos los materiales precargados antes de guardar',
                type: 'warning',
                open: true
            });
            operationInProgressRef.current = false;
            setOperationInProgress(false);
            setIsOnSave(false);
            return;
        }

        if (validateResult) {

            // Logging para detectar problemas de concurrencia
            console.log('Iniciando guardado de materiales - Timestamp:', Date.now());
            console.log('Seriales antes del guardado:', {
                ont: state.serialOnt,
                flow: state.serialesFlow,
                ext: state.serialesExt
            });
            console.log('Seriales disponibles en cuadrilla:', cuadrilla?.seriales?.length || 0);
            let serialsOnt = state.serialOnt;
            let serialsFlow = state.serialesFlow;
            let serialsExt = state.serialesExt;
            if (isMudanza && state.serialesToSave?.length > 0) {
                state.serialesToSave?.map(serial => {
                    const tipo = (serial?.tipo || '').trim().toLowerCase();
                    const id = String(serial?.id || '').trim();
                    if (tipo === 'ont') {
                        serialsOnt.push(id)
                        return setState(prevState => ({ ...prevState }))
                    } else if (tipo === 'ext') {
                        serialsExt.push(id)
                        return setState(prevState => ({ ...prevState }))

                    } else {
                        serialsFlow.push(id)
                        return setState(prevState => ({ ...prevState }))
                    }
                })
            }

            // Identificar si se cargaron materiales de forma manual o se modificaron cantidades en una orden precargada
            const hasManualMaterials = state.materialsToSave.some(mToSave => {
                const precargado = materialesPrecargados.find(p => p.materialId === mToSave.id);
                if (!precargado) return true; // Material nuevo agregado manualmente
                return parseInt(mToSave.value, 10) !== parseInt(precargado.cantidad, 10); // Cantidad modificada
            });

            console.log('📊 ¿Tiene materiales manuales/modificados?', hasManualMaterials);

            let dataToSave = {
                materials: state.materialsToSave,
                serialOnt: serialsOnt,
                serialesFlow: serialsFlow,
                serialesExt: serialsExt,
                ontRetirado: state.ontRetirado,
                decoRetirado: state.decoRetirado,
                extRetirado: state.extRetirado,
                ontBodega: state.ontBodega,
                flowBodega: state.flowBodega,
                extBodega: state.extBodega,
                controles: state.controles,
                serialesConfigurados: state.serialesConfigurados,
                checkField: state.checkField,
                noRequiereMateriales: noRequiereMaterialesFM,
                hasManualMaterials: hasManualMaterials && data?.isManualOrder === false
            };
            setIsOnSave(true)

            try {
                // ✅ CORREGIDO: Guardar la orden PRIMERO, y procesar materiales SOLO si es exitoso
                console.log('💾 Guardando orden primero...');

                await onSave(dataToSave, async () => {
                    // ✅ Este callback se ejecuta SOLO si la orden se guardó exitosamente
                    console.log('✅ Orden guardada exitosamente, ahora procesando materiales...');

                    await processMaterialsAndSerials();
                });

                console.log('✅ Proceso completo finalizado');

            } catch (orderError) {
                console.error('❌ Error al guardar la orden:', orderError);
                setSnackbarInfo({
                    text: `Error al guardar la orden: ${orderError.message}`,
                    type: 'error',
                    open: true
                });
            } finally {
                operationInProgressRef.current = false;
                setOperationInProgress(false);
                setIsOnSave(false);
            }
        } else {
            // ✅ Manejar validaciones fallidas
            console.warn('Validaciones fallidas, no se procesa la orden');
            operationInProgressRef.current = false;
            setOperationInProgress(false);
            setSnackbarInfo({
                text: 'Por favor corrija los errores en el formulario antes de continuar',
                type: 'error',
                open: true
            });
        }
    }

    // Función separada para procesar materiales y seriales
    const processMaterialsAndSerials = async () => {
        try {
            // ✅ CORREGIDO: Preparar cuadrilla actualizada y obtener el objeto modificado
            console.log('🔄 Preparando cuadrilla con datos actualizados desde BD...');

            // Mostrar mensaje al usuario sobre la actualización de datos
            setSnackbarInfo({
                text: 'Verificando datos más recientes de la cuadrilla...',
                type: 'info',
                open: true
            });

            const cuadrillaModificada = await prepararCuadrillaModificada();

            // Procesar materiales de forma secuencial para evitar conflictos
            const materialPromises = state.materialsToSave.map(async (mate) => {
                const filterMaterialsByCuadrilla = materialsCuadrilla.filter(
                    cuadrilla => cuadrilla.idMaterial === parseInt(mate.id, 10)
                );

                if (filterMaterialsByCuadrilla.length > 0) {
                    for (const matxcuad of filterMaterialsByCuadrilla) {
                        const quantityStock = matxcuad.cantidad - parseInt(mate.value, 10);

                        const docRef = doc(firestore, 'materialsxcuadrilla', `${matxcuad.idCuadrilla}c${matxcuad.idMaterial}`);
                        await updateDoc(docRef, { cantidad: quantityStock });
                    }
                } else {
                    const idCuadrilla = parseInt(cuadrillaSelected.id, 10);
                    const idMaterial = parseInt(mate.id, 10);
                    const dataToStock = {
                        cantidad: -parseInt(mate.value, 10),
                        idCuadrilla,
                        idMaterial,
                    };

                    const docRef = doc(firestore, 'materialsxcuadrilla', `${idCuadrilla}c${idMaterial}`);
                    await setDoc(docRef, dataToStock);
                }
            });

            // Esperar a que se completen todas las operaciones de materiales
            await Promise.all(materialPromises);
            console.log('Materiales actualizados correctamente');

            // ✅ CORREGIDO: Usar el ID confiable y actualizar únicamente seriales y controles para evitar pisar otros campos concurrentes
            const targetCuadrillaId = cuadrillaModificada?.id !== undefined
                ? cuadrillaModificada.id
                : (cuadrilla?.id !== undefined ? cuadrilla.id : parseInt(cuadrillaSelected.id, 10));

            console.log('🔄 Actualizando cuadrilla con seriales modificados...');
            console.log('📊 Resumen antes de guardar en BD:');
            console.log(`   - ID Cuadrilla: ${targetCuadrillaId}`);
            console.log(`   - Seriales originales (cache): ${cuadrilla.seriales?.length || 0}`);
            console.log(`   - Seriales actualizados (BD): ${cuadrillaModificada.seriales?.length || 0}`);
            console.log(`   - Seriales a remover: ${[...state.serialOnt, ...state.serialesFlow, ...state.serialesExt].length}`);

            // Mostrar los seriales que se van a remover para debugging
            const serialesARemover = [...state.serialOnt, ...state.serialesFlow, ...state.serialesExt];
            if (serialesARemover.length > 0) {
                console.log('🔸 Seriales que se van a remover:', serialesARemover);
            }

            await updateCuadrillaConRegistro(targetCuadrillaId, {
                seriales: cuadrillaModificada.seriales || [],
                controles: cuadrillaModificada.controles || []
            }, null, {
                tipoOperacion: 'CONSUMO_SERIALES_ORDEN',
                componenteOrigen: 'AddMaterials',
                idOrden: data?.id || data?.nroOt || 'pendiente',
                motivoActualizacion: 'USO_MATERIALES'
            });
            console.log('✅ Cuadrilla actualizada exitosamente');

            // Si se utilizaron seriales de Bodega (ontBodega, flowBodega, extBodega), descontarlos también de Bodega
            const serialesBodegaUsados = [
                ...(state.ontBodega || []),
                ...(state.flowBodega || []),
                ...(state.extBodega || [])
            ].map(s => String(typeof s === 'object' ? s?.id : s || '').trim().toUpperCase()).filter(Boolean);

            if (serialesBodegaUsados.length > 0 && targetCuadrillaId !== idCuadrillaBodega) {
                try {
                    const bodegaActualizada = await getCuadrillaActualizada(idCuadrillaBodega);
                    if (bodegaActualizada && Array.isArray(bodegaActualizada.seriales)) {
                        const bodegaSet = new Set(serialesBodegaUsados);
                        const nuevosSerialesBodega = bodegaActualizada.seriales.filter(
                            s => !bodegaSet.has(String(s?.id || '').trim().toUpperCase())
                        );
                        if (nuevosSerialesBodega.length !== bodegaActualizada.seriales.length) {
                            await updateCuadrillaConRegistro(idCuadrillaBodega, {
                                seriales: nuevosSerialesBodega
                            }, null, {
                                tipoOperacion: 'CONSUMO_SERIALES_ORDEN_BODEGA',
                                componenteOrigen: 'AddMaterials',
                                idOrden: data?.id || data?.nroOt || 'pendiente',
                                motivoActualizacion: 'USO_MATERIALES_BODEGA'
                            });
                            console.log('✅ Seriales de Bodega descontados exitosamente');
                        }
                    }
                } catch (bodegaErr) {
                    console.warn('⚠️ No se pudieron descontar los seriales de Bodega:', bodegaErr);
                }
            }

            // Registrar el uso de materiales y consumo de seriales
            try {
                const serialesUsados = [
                    ...state.serialOnt,
                    ...state.serialesFlow,
                    ...state.serialesExt
                ];

                console.log('📝 Preparando registro de uso de materiales...');
                console.log('📊 Seriales usados:', serialesUsados);
                console.log('📊 ID Orden:', data?.id || data?.nroOt || 'pendiente');

                if (serialesUsados.length > 0) {
                    // Convertir IDs a formato de objeto con tipo
                    const serialesUsadosFormatted = serialesUsados.map(serialId => {
                        // Buscar el serial en los arrays originales para obtener el tipo
                        const serialInCuadrilla = cuadrilla.seriales?.find(s => s.id === serialId);
                        return serialInCuadrilla || { id: serialId, tipo: 'desconocido' };
                    });

                    await registrarUsoMateriales({
                        tipoOperacion: 'USO_MATERIALES_ORDEN',
                        componenteOrigen: 'AddMaterials',
                        idOrden: data?.id || data?.nroOt || 'pendiente',
                        idCuadrilla: cuadrilla.id,
                        serialesUsados: serialesUsadosFormatted,
                        metadatos: {
                            // Información de la orden
                            nroOt: data?.nroOt,
                            nroFormulario: data?.nroFormulario,
                            cliente: data?.cliente,
                            tipoOt: data?.tipoOt,
                            cuadrilla: data?.cuadrilla,
                            // Información de materiales y seriales
                            materiales: state.materialsToSave,
                            controles: state.controles,
                            isMudanza: isMudanza,
                            comentarios: state.comentarios || state.comments,
                            serialesManuales: state.serialesToSave?.length || 0,
                            // Detalle de seriales por tipo
                            serialesOnt: state.serialOnt,
                            serialesFlow: state.serialesFlow,
                            serialesExt: state.serialesExt,
                            fecha: new Date().toISOString(),
                            usuarioActualizacion: currentUser?.email || 'SISTEMA'
                        }
                    });
                    console.log('✅ Registro de uso de materiales creado exitosamente');
                    console.log('📋 Detalles del registro:', {
                        idOrden: data?.id || data?.nroOt || 'pendiente',
                        idCuadrilla: cuadrilla.id,
                        cantidadSeriales: serialesUsadosFormatted.length
                    });
                } else {
                    console.log('ℹ️ No hay seriales para registrar (ningún serial seleccionado)');
                }
            } catch (errorRegistro) {
                console.error('❌ Error al crear registro de uso de materiales:', errorRegistro);
                // No interrumpir el flujo si falla el registro
            }

            // Mensaje final de éxito con información de la operación
            const totalSerialesUsados = [...state.serialOnt, ...state.serialesFlow, ...state.serialesExt].length;
            const mensajeExito = totalSerialesUsados > 0
                ? `Orden guardada exitosamente. Se procesaron ${totalSerialesUsados} seriales.`
                : 'Orden guardada exitosamente.';

            setSnackbarInfo({
                text: mensajeExito,
                type: 'success',
                open: true
            });

            setClearForm();

        } catch (error) {
            console.error('❌ Error procesando materiales y seriales:', error);

            // Determinar el tipo de error para mostrar mensaje específico
            let mensajeError = 'Ocurrió un error al procesar los materiales.';

            if (error.message?.includes('Timeout')) {
                mensajeError = 'La operación tardó demasiado. Verifique su conexión.';
            } else if (error.message?.includes('cuadrilla')) {
                mensajeError = 'Error al obtener datos actualizados de la cuadrilla.';
            }

            setSnackbarInfo({
                text: mensajeError,
                type: 'error',
                open: true
            });
            throw error; // Re-lanzar para que el callback de onSave maneje el error
        } finally {
            operationInProgressRef.current = false;
            setOperationInProgress(false);
            setIsOnSave(false);
        }
    };

    // Código comentado para referencia futura
    // const cuadrillaRef = ref(database, 'cuadrillas/' + cuadrilla.id);
    // const materialsxcuadrillaRefs = [];

    // state.materialsToSave.forEach(mate => {
    //     const filterMaterialsByCuadrilla = materialsCuadrilla.filter(
    //         cuadrilla => cuadrilla.idMaterial === parseInt(mate.id, 10)
    //     );

    //     if (filterMaterialsByCuadrilla.length > 0) {
    //         filterMaterialsByCuadrilla.forEach(matxcuad => {
    //             const quantityStock = matxcuad.cantidad - parseInt(mate.value, 10);
    //             const materialxcuadrillaRef = ref(database, 'materialsxcuadrilla/' + matxcuad.idCuadrilla + 'c' + matxcuad.idMaterial);
    //             materialsxcuadrillaRefs.push({ ref: materialxcuadrillaRef, data: { cantidad: quantityStock } });
    //         });
    //     } else {
    //         const idCuadrilla = parseInt(cuadrillaSelected.id, 10);
    //         const idMaterial = parseInt(mate.id, 10);
    //         const materialxcuadrillaRef = ref(database, 'materialsxcuadrilla/' + idCuadrilla + 'c' + idMaterial);
    //         materialsxcuadrillaRefs.push({ ref: materialxcuadrillaRef, data: { cantidad: -parseInt(mate.value, 10), idCuadrilla, idMaterial } });
    //     }
    // });

    // runTransaction(cuadrillaRef, (cuadrillaData) => {
    //     // Realiza las operaciones dentro de la transacción para cuadrillaData

    //     materialsxcuadrillaRefs.forEach(({ ref, data }) => {
    //         update(ref, data);
    //     });

    //     update(cuadrillaRef, cuadrilla)
    //     // cuadrillaData.lastUpdate = Date.now(); // Puedes realizar otras operaciones en cuadrillaData según sea necesario

    //     return cuadrillaData;
    // })
    //     .then(() => {
    //         console.log('Transacción exitosa');
    //         setTimeout(() => {
    //             setClearForm();
    //         }, 500);
    //         onSave(dataToSave);
    //     })
    //     .catch((error) => {
    //         console.error('Ocurrió un error durante la transacción:', error);
    //         setSnackbarInfo({ text: 'Ocurrió un error al guardar la OT, intente nuevamente', type: 'error', open: true });
    //     });

    const setClearForm = () => {
        setState({
            idOt: id,
            materials: [],
            materialsToSave: [],
            serialOnt: [],
            serialesFlow: [],
            serialesExt: [],
            ontRetirado: [],
            decoRetirado: [],
            dropExternoRetirado: [],
            serialesToSave: [],
            ontBodega: [],
            flowBodega: [],
            extBodega: [],
            controles: [],
            serialesConfigurados: {},
            submitted: true,
        })
        setSerialConfigList([
            <TextField
                id="outlined-number"
                label="Serial equipo configurado"
                type="number"
                onWheel={(e) => e.target.blur()}
                className="text-form__serial"
                onChange={(e) => onChangeValues(e, 0)}
                InputLabelProps={{
                    shrink: true,
                }}
                sx={{ marginBottom: '20px', marginRight: '10px' }}
            />
        ]);
        setMaterialsCuadrilla([]);
    }

    const onChangeTipoSerial = (e, index) => {
        e.preventDefault();
        const value = typeof e.target.value === 'string' ? e.target.value.trim().toLowerCase() : e.target.value;

        // ✅ ARREGLADO: Crear nueva copia del array en lugar de mutación directa
        setState(prevState => {
            const newSerialsToSave = [...(prevState.serialesToSave || [])];

            if (newSerialsToSave[index]) {
                newSerialsToSave[index] = {
                    ...newSerialsToSave[index],
                    tipo: value
                };
            } else {
                newSerialsToSave[index] = {
                    tipo: value,
                    index: index
                };
            }

            return { ...prevState, serialesToSave: newSerialsToSave };
        });
    }

    const onChangeManualSerial = (e, index) => {
        const rawValue = e.target.value;
        const name = e.target.name;
        const value = typeof rawValue === 'string' && name === 'id' ? rawValue.trim() : rawValue;

        // ✅ ARREGLADO: Crear nueva copia del array en lugar de mutación directa
        setState(prevState => {
            let newSerialsToSave = [...(prevState.serialesToSave || [])];

            if (value === '') {
                // Remover el elemento si está vacío
                newSerialsToSave = newSerialsToSave.filter((_, i) => i !== index);
            } else {
                if (newSerialsToSave[index]) {
                    newSerialsToSave[index] = {
                        ...newSerialsToSave[index],
                        [name]: value
                    };
                } else {
                    newSerialsToSave[index] = {
                        id: value,
                        index: index
                    };
                }
            }

            return { ...prevState, serialesToSave: newSerialsToSave };
        });
    }

    const bodegaSerialOnt = bodega?.seriales?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'ont') || [];
    const bodegaSerialFlow = bodega?.seriales?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'flow') || [];
    const bodegaSerialExt = bodega?.seriales?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'ext') || [];
    const cuadrillaSerialOnt = cuadrilla?.seriales?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'ont') || [];
    const cuadrillaSerialFlow = cuadrilla?.seriales?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'flow') || [];
    const cuadrillaSerialExt = cuadrilla?.seriales?.filter(serial => (serial?.tipo || '').trim().toLowerCase() === 'ext') || [];

    const rows = [];
    if (isMudanza) {
        for (let i = 0; i < 10; i++) {
            const serialCharge = state.serialesToSave[i] || { tipo: '', observaciones: '', id: '' };
            rows.push(
                <InputSerials
                    index={i}
                    serialCharge={serialCharge}
                    onChangeTipoSerial={onChangeTipoSerial}
                    onChangeValues={onChangeManualSerial}
                    observations={false}
                />);
        }
    }

    const onAcceptSerial = (e) => {
        e.preventDefault();
        setOpenModalAdd(false);
    }

    const resetIdentificadores = () => {

    }

    const onChangeCheck = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            countDigits(data?.contrato, state.materials);
        } else {
            const filteredMaterials = state.materialsToSave.filter(material => material.id < 27 || material.id > 36);
            setState(prevState => ({
                ...prevState,
                materialsToSave: filteredMaterials
            }));

        }
    }

    const onChangeCheckField = (e) => {
        const isChecked = e.target.checked;
        setState(prevState => ({
            ...prevState,
            checkField: isChecked
        }));
    }

    return (
        <Container component="main">
            <>
                <Typography component="h2" variant="h6" sx={{ color: '#565e5e', marginBottom: '20px' }}>
                    Cuadrilla: <b>{cuadrillaSelected?.numero}</b>
                </Typography>

                {noRequiereMaterialesFM && (
                    <MuiAlert severity="info" sx={{ marginBottom: 2 }}>
                        Field Manager indica que esta OT no requiere descarga de materiales.
                    </MuiAlert>
                )}

                {materialesPrecargados && materialesPrecargados.length > 0 && (
                    <Box sx={{
                        marginBottom: 3,
                        padding: 2,
                        border: '2px solid #bcb4b4',
                        borderRadius: 1,
                        backgroundColor: '#ebe9e9'
                    }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }} onClick={() => setExpandirMateriales(!expandirMateriales)}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                <Typography variant="h6" sx={{ color: '#000', marginRight: 1 }}>
                                    📦 Materiales precargados ({materialesPrecargados.length})
                                </Typography>
                                {todosMaterialesPrecargadosValidados() && (
                                    <Typography variant="body2" sx={{ color: 'green', fontWeight: 'bold' }}>
                                        ✓ Todos revisados
                                    </Typography>
                                )}
                            </Box>
                            <Typography sx={{ color: '#000', fontWeight: 'bold', fontSize: '1.5rem' }}>
                                {expandirMateriales ? '▼' : '▶'}
                            </Typography>
                        </Box>

                        {expandirMateriales && (
                            <>
                                <Typography variant="body2" sx={{ marginBottom: 2, marginTop: 2, color: '#666' }}>
                                    Revisa y marca el checkbox de cada material para confirmar que fue verificado.
                                </Typography>
                                {materialesPrecargados.map((material) => (
                                    <Box
                                        key={material.materialId}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: 1.5,
                                            marginBottom: 1,
                                            border: '1px solid #bcb4b4',
                                            borderRadius: 0.5,
                                            backgroundColor: materialesValidados[material.materialId] ? '#C8E6C9' : '#FFF',
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        <Checkbox
                                            checked={materialesValidados[material.materialId] || false}
                                            onChange={() => handleValidarMaterialPrecargado(material.materialId)}
                                            sx={{ marginRight: 1 }}
                                        />
                                        <Box sx={{ flex: 1 }}>
                                            <Tooltip title="Cantidad">
                                                <Box component="span" sx={{ fontSize: '1.1rem', fontWeight: 700, color: 'primary.main' }}>{material.cantidad}</Box>
                                            </Tooltip>
                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                {material.name} | 
                                                 <Box component="span" sx={{ color: '#666' }}> Código: {material.codigo} </Box> 
                                            </Typography>
                                        </Box>
                                        {materialesValidados[material.materialId] && (
                                            <Typography variant="body2" sx={{ color: 'green', fontWeight: 'bold' }}>
                                                ✓ Revisado
                                            </Typography>
                                        )}
                                    </Box>
                                ))}
                            </>
                        )}
                    </Box>
                )}

                <Stack direction="row" spacing={2} sx={{ marginBottom: '20px' }}>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            // multiple
                            id="checkboxes-tags-demo"
                            options={cuadrillaSerialOnt}
                            disablePortal
                            disabled={state.ontBodega?.length > 0}
                            onChange={(e, serials) => onChangeSerialOnt(e, serials)}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="Serial ONT" placeholder="Serial ONT" />
                            )}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={cuadrillaSerialFlow}
                            disabled={data?.services[0]?.id === servicesId.BASICA1P}
                            disableCloseOnSelect
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'serialesFlow')}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="Serial FLOW" placeholder="Serial FLOW" />
                            )}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={cuadrillaSerialExt}
                            disablePortal
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'serialesExt')}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="Serial Ext" placeholder="Serial Ext" />
                            )}
                        />
                    </FormControl>
                </Stack>
                {isMudanza &&
                    <Stack>
                        <Button
                            variant="outlined"
                            endIcon={<AddCircleOutlinedIcon />}
                            onClick={(event) => {
                                event.preventDefault();
                                setOpenModalAdd(true)
                            }}
                            sx={{ width: '50%', margin: '0 auto 35px' }}
                        >
                            Agregar seriales manualmente
                        </Button>
                        <Dialog open={openModalAdd} onClose={() => setOpenModalAdd(false)}>
                            <DialogTitle>Agregar seriales</DialogTitle>
                            <DialogContent>
                                {rows}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={(e) => onAcceptSerial(e)}>Aceptar</Button>
                            </DialogActions>
                        </Dialog>
                    </Stack>
                }
                {/* <Stack direction="row" spacing={2} sx={{ marginBottom: '20px' }}>
                    {/* <TextField
                        id="outlined-number"
                        label="Control deco SAGEMCOM"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="text-form__main-materials"
                        onChange={(e) => onChangeControles(e, 0, 'sagemcom')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{ margin: '0, 10px', flexBasis: '25%' }}
                    />
                    <TextField
                        id="outlined-number"
                        label="Control deco SAGEMCOM Reac."
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="text-form__main-materials"
                        onChange={(e) => onChangeControles(e, 1, 'sagemcom reacondicionado')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{ margin: '0, 10px', flexBasis: '25%' }}
                    /> 
                    <TextField
                        id="outlined-number"
                        label="Control deco Android"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="text-form__main-materials"
                        onChange={(e) => onChangeControles(e, 2, 'android')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{ margin: '0, 10px', flexBasis: '50%' }}
                    />
                    <TextField
                        id="outlined-number"
                        label="Control deco Android Reac."
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="text-form__main-materials"
                        onChange={(e) => onChangeControles(e, 3, 'android reacondicionado')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{ margin: '0, 10px', flexBasis: '50%' }}
                    />
                </Stack>
                {state.serialesFlow?.length > 0 && state.controles?.length === 0 &&
                    <MuiAlert severity="warning">
                        No se colocó ningún valor para controles y se seleccionó al menos un serial FLOW
                    </MuiAlert>
                } */}
                <Stack direction="row" spacing={2} sx={{ marginBottom: '20px' }}>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={bodegaSerialOnt}
                            disableCloseOnSelect
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'ontRetirado')}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="ONT retirado" placeholder="ONT retirado" />
                            )}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={bodegaSerialFlow}
                            disableCloseOnSelect
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'decoRetirado')}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="Deco retirado" placeholder="Deco retirado" />
                            )}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={cuadrillaSerialExt}
                            disablePortal
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'extRetirado')}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="Ext Retirado" placeholder="Ext Retirado" />
                            )}
                        />
                    </FormControl>
                </Stack>
                {serialConfigList}
                <IconButton aria-label="add" onClick={(e) => onAddBtnClick(e, 'serial')}>
                    <AddCircleOutlinedIcon />
                </IconButton>
                <Stack direction="row" spacing={2} sx={{ marginBottom: '20px' }}>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            options={bodegaSerialOnt}
                            disableCloseOnSelect
                            disabled={state.serialOnt?.length > 0}
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'ontBodega')}
                            getOptionLabel={(option) => option.id}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="ONT instalado bodega" placeholder="ONT instalado bodega" />
                            )}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={bodegaSerialFlow}
                            disableCloseOnSelect
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'flowBodega')}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="Flow instalado bodega" placeholder="Flow instalado bodega" />
                            )}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '50%' }}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={bodegaSerialExt}
                            disableCloseOnSelect
                            onChange={(e, serials) => onChangeSeriales(e, serials, 'extBodega')}
                            getOptionLabel={(option) => option.id}
                            renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.id}
                                </li>
                            )}
                            style={{ width: '100%', margin: '10px 0' }}
                            renderInput={(params) => (
                                <TextField {...params} label="Ext instalado bodega" placeholder="Ext instalado bodega" />
                            )}
                        />
                    </FormControl>
                </Stack>
                <Box sx={{ display: 'flex', flexDirection: 'initial' }} className="box-container">
                    <FormControl component="fieldset" variant="standard">
                        <FormGroup sx={{ flexDirection: 'initial' }}>
                            {state?.materials?.map(material => {
                                const stock = materialsCuadrilla.filter(mater => mater.idMaterial === material?.id)[0]?.cantidad || '-';
                                const foundMaterial = state?.materialsToSave?.filter(mater => mater?.id === material?.id);
                                const filterValue = foundMaterial[0]?.value ? foundMaterial[0]?.value : '';
                                return (
                                    material?.visible &&
                                    <TextField
                                        id="outlined-number"
                                        label={material?.name}
                                        value={filterValue}
                                        type="number"
                                        placeholder={`Stock: ${stock}`}
                                        onWheel={(e) => e.target.blur()}
                                        className="text-form__material"
                                        onChange={(e) => changeInput(e, material?.id, material?.name)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ flexBasis: '18%', margin: '7px 5px 7px 0' }}
                                    />
                                )
                            })}
                        </FormGroup>
                    </FormControl>
                </Box>
                <div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                onChange={(e) => onChangeCheck(e)}
                                defaultChecked={false}
                            />
                        }
                        label="Utilizó identificadores"
                        className="label-check"
                        sx={{ flexBasis: '49%' }}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                onChange={(e) => onChangeCheckField(e)}
                                checked={!!state.checkField}
                            />
                        }
                        label="No descargó materiales en Field Manager"
                        className="label-check"
                        sx={{ flexBasis: '49%' }}
                    />
                </div>

                {alertValidationAdaptadorMecanico !== '' && <MuiAlert severity="error">{alertValidationAdaptadorMecanico}</MuiAlert>}
                {alertValidationRoseta !== '' && <MuiAlert severity="error">{alertValidationRoseta}</MuiAlert>}
                {alertValidationConectorSc !== '' && <MuiAlert severity="error">{alertValidationConectorSc}</MuiAlert>}
                {alertValidationRetenedor !== '' && <MuiAlert severity="error">{alertValidationRetenedor}</MuiAlert>}
                {alertValidationDropExterno !== '' && <MuiAlert severity="error">{alertValidationDropExterno}</MuiAlert>}
                {alertValidationCintas !== '' && <MuiAlert severity="error">{alertValidationCintas}</MuiAlert>}
                {alertValidationPreco50 !== '' && <MuiAlert severity="error">{alertValidationPreco50}</MuiAlert>}
                {alertValidationPreco100 !== '' && <MuiAlert severity="error">{alertValidationPreco100}</MuiAlert>}
                {alertValidationPreco150 !== '' && <MuiAlert severity="error">{alertValidationPreco150}</MuiAlert>}
                {alertValidationPreco220 !== '' && <MuiAlert severity="error">{alertValidationPreco220}</MuiAlert>}
                {alertValidationPreco300 !== '' && <MuiAlert severity="error">{alertValidationPreco300}</MuiAlert>}
                {alertValidationSerialOnt !== '' && <MuiAlert severity="error">{alertValidationSerialOnt}</MuiAlert>}
                {alertValidationSerialFlow !== '' && <MuiAlert severity="error">{alertValidationSerialFlow}</MuiAlert>}
                {alertValidationRj !== '' && <MuiAlert severity="error">{alertValidationRj}</MuiAlert>}

                {isOnSave ? (
                    <LoadingButton
                        fullWidth
                        loading
                        variant="contained"
                        color="primary"
                        className="button__save"
                        sx={{ margin: '15px 0', width: '50%' }}
                    >
                        Aceptar
                    </LoadingButton>
                ) : (
                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className="button__save"
                        onClick={saveMaterials}
                        sx={{ margin: '15px 0', width: '50%' }}
                        disabled={!todosMaterialesPrecargadosValidados()}
                    >
                        Aceptar
                    </Button>
                )}
            </>
            <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default AddMaterials
